import { render, staticRenderFns } from "./SessionRecorder.vue?vue&type=template&id=b22c95c6&scoped=true&"
import script from "./SessionRecorder.vue?vue&type=script&lang=js&"
export * from "./SessionRecorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22c95c6",
  null
  
)

export default component.exports